module.exports = function() {
    //handle hover
    $('.secondary-navigation .menu-item').hover(function(event) {
        // if screen is tablet size and has tablet menu item, show it on hover otherwise it will break the desktop link
        if ((window.innerWidth > 767 && window.innerWidth < 1025) &&
            $(this).find('.touch-device-menu-item').length > 0) {
            $('.touch-device-menu-item').show();
        } else {
            $('.touch-device-menu-item').hide();
        }
    });
    //handle click -- this makes the main menu function on tablet (since main menu has clickable links that will only show on hover)
    $('.secondary-navigation .menu-item').on('click',
        '.accordion-heading a.navigation-sub',
        function(event) {
            if (window.innerWidth > 767 && window.innerWidth < 1025) {
                if ($(this).closest('.menu-item').find('.navigation-sub-menu').length > 0) { // if has a dropdown
                    event.preventDefault();
                    $('.touch-device-menu-item').show();
                } else {
                    $('.touch-device-menu-item').hide();
                }
            }
        });
};